module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO47FormulaPatrimonio.30351fd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO47FormulaPatrimonio.mp4
// module id = 773
// module chunks = 1